import React, { useEffect, useState, useMemo } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import DataTable from "react-data-table-component";
import moment from "moment";

import useExpiredTransactions from "../../queries/transaction/getExpiredTransactions";
import Loader from "../../components/Loader";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
} from "../../components/ListPage";

const ExpiredTransactions = () => {
  const [transactionTable, setTransactionTable] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedYear, setSelectedYear] = useState("last12months");
  const [availableYears, setAvailableYears] = useState([]);

  // Generate available years (last 5 years and current year)
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i);
    setAvailableYears(years);
  }, []);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let columns = [
    {
      name: "Guest ID",
      selector: "guestId",
      sortable: true,
    },
    {
      name: "Reservation ID",
      selector: "reservationId",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row, index, column, id) => {
        return <span>{capitalizeFirstLetter(row.status)}</span>;
      },
    },
    {
      name: "Created At",
      selector: "createdAt",
      sortable: true,
      cell: (row, index, column, id) => {
        return (
          <span>{moment(row.createdAt).format("DD MMM YYYY hh:mm:ss A")}</span>
        );
      },
    },
  ];

  const [response, reset] = useExpiredTransactions(selectedYear);

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = useMemo(() => {
    if (!response.data) return [];

    return response.data.filter((item) => {
      const matchesSearch = filterText
        ? (item.guestId &&
            item.guestId.toLowerCase().includes(filterText.toLowerCase())) ||
          (item.reservationId &&
            item.reservationId.toLowerCase().includes(filterText.toLowerCase()))
        : true;

      return matchesSearch;
    });
  }, [response.data, filterText]);

  useEffect(() => {
    if (response.data) {
      setTransactionTable([...response.data]);
    }
  }, [response]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          <FormControl
            variant="outlined"
            size="small"
            style={{ minWidth: 120 }}
          >
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear}
              onChange={handleYearChange}
              label="Year"
            >
              <MenuItem value="last12months">Last 12 Months</MenuItem>
              {availableYears.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="filter-text"
            onChange={handleFilterText}
            label="Search"
            variant="outlined"
            size="small"
            value={filterText}
          />
        </div>
      </div>
    );
  }, [filterText, availableYears, selectedYear]);

  return (
    <ListPageShell>
      <ListPageCard>
        {response.loading && <Loader />}
        {!response.loading && (
          <div>
            <ListPageHeader title="Expired Transactions" />
            <DataTable
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 30]}
              noHeader={true}
              subHeader
              data={filteredItems}
              columns={columns}
              subHeaderComponent={subHeaderComponentMemo}
              customStyles={dataTableCustomStyles}
            />
          </div>
        )}
      </ListPageCard>
    </ListPageShell>
  );
};

export default ExpiredTransactions;
